import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Label, Input, Form } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { http } from "../../http"; // ✅ direct API
import { Roles, NormalRoles } from "../../import/AddRole";

const injectOnce = () => {
  if (document.getElementById("group-edit-inline-css")) return;
  const s = document.createElement("style");
  s.id = "group-edit-inline-css";
  s.textContent = `
    .p-card{ border-radius:14px; border:1px solid #e5e7eb; }
    .grp-row{ border:1px solid #e5e7eb; border-radius:10px; overflow:hidden; }
    .grp-head{ display:flex; align-items:center; gap:10px; padding:10px 12px; background:#f4f7f6; cursor:pointer; }
    .grp-head:hover{ background:#f1f5f9; }
    .grp-title{ font-weight:700; }
    .pill{ border:1px solid #e5e7eb; padding:2px 8px; border-radius:999px; font-size:12px; background:#fff; }
    .perm-row{ display:flex; align-items:center; gap:8px; padding:8px 12px; border-top:1px solid #f1f5f9; }
    .perm-col{ flex:1; display:flex; justify-content:center; }
    .perm-name{ flex:2; text-align:left; font-weight:600; }
    .toggle{ min-width:20px; font-weight:800; user-select:none; }
  `;
  document.head.appendChild(s);
};

export default function GroupEdit() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [groupName, setGroupName] = useState("");
  const [groupDesc, setGroupDesc] = useState("");
  const [status, setStatus] = useState("Active");

  const [isMaster, setIsMaster] = useState(false);
  const [blueprints, setBlueprints] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [selected, setSelected] = useState([]);

  useEffect(() => injectOnce(), []);

  useEffect(() => {
    (async () => {
      try {
        const user = JSON.parse(localStorage.getItem("userData") || "{}");
        const master = user?.rolename?.roleName === "MASTER";
        setIsMaster(master);
        setBlueprints(master ? Roles || [] : NormalRoles || []);
      } catch {
        setBlueprints(NormalRoles || []);
      }

      const { data } = await http.get(`/groups/by-id/${id}`); // ✅ direct URL
      const g = data?.Group;
      setGroupName(g?.groupName || "");
      setGroupDesc(g?.groupDesc || "");
      setStatus(g?.status || "Active");
      setSelected(Array.isArray(g?.permissions) ? g.permissions : []);
    })().catch(() => swal("Failed to load group"));
  }, [id]);

  const toggleGroup = (idx) => setExpanded((p) => ({ ...p, [idx]: !p[idx] }));
  const getTabPerm = (t) =>
    selected.find((x) => x.pagename === t)?.permission || [];
  const setTabPerm = (t, perms) => {
    const clean = perms.filter((p) => p && p !== "NA");
    setSelected((prev) => {
      const ex = prev.find((x) => x.pagename === t);
      if (!clean.length) return prev.filter((x) => x.pagename !== t);
      if (ex)
        return prev.map((x) =>
          x.pagename === t ? { ...x, permission: clean } : x
        );
      return [...prev, { pagename: t, permission: clean }];
    });
  };
  const onTogglePerm = (t, perm, checked) => {
    const cur = getTabPerm(t);
    setTabPerm(
      t,
      checked
        ? Array.from(new Set([...cur, perm]))
        : cur.filter((p) => p !== perm)
    );
  };
  const onSelectAllInGroup = (group, checked) => {
    (group?.TabName || []).forEach((tab) => {
      const all = (tab?.permission || []).filter((p) => p !== "NA");
      setTabPerm(tab?.title, checked ? all : []);
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        groupName: groupName.trim(),
        groupDesc: groupDesc.trim(),
        status,
        permissions: selected,
      };
      const { data } = await http.put(`/groups/update/${id}`, payload); // ✅ direct URL
      if (data?.status) {
        swal("Updated");
        navigate(-1);
      } else {
        swal(data?.message || "Update failed");
      }
    } catch {
      swal("Update failed");
    }
  };

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col sm="12">
          <Card
            className="p-card"
            style={{ padding: 8, background: "#f4f7f6" }}
          >
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  textTransform: "uppercase",
                  fontSize: 18,
                }}
              >
                Edit Group
              </div>
              <div style={{ flex: "1 1 240px" }} />
              <Button
                style={{
                  backgroundColor: "rgb(8, 91, 245)",
                  color: "#fff",
                  fontWeight: 600,
                  height: 32,
                }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl={12}>
          <Card className="p-card" style={{ padding: 14 }}>
            <Form onSubmit={submit}>
              <Row style={{ gap: 12 }}>
                <Col md="4" sm="12">
                  <Label>Group Name *</Label>
                  <Input
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </Col>
                <Col md="6" sm="12">
                  <Label>Description</Label>
                  <Input
                    value={groupDesc}
                    onChange={(e) => setGroupDesc(e.target.value)}
                  />
                </Col>
                <Col md="2" sm="12">
                  <Label>Status</Label>
                  <Input
                    type="select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option>Active</option>
                    <option>Deactive</option>
                  </Input>
                </Col>
              </Row>

              <div style={{ marginTop: 14 }}>
                {Array.isArray(blueprints) &&
                  blueprints.map((group, gi) => {
                    const isOpen = !!expanded[gi];
                    const allPerms = (group?.TabName || []).flatMap((t) =>
                      (t?.permission || []).filter((p) => p !== "NA")
                    );
                    const titles = (group?.TabName || []).map((t) => t?.title);
                    const selectedInGroup = selected
                      .filter((s) => titles.includes(s.pagename))
                      .flatMap((s) => s.permission);
                    const allChecked =
                      allPerms.length > 0 &&
                      allPerms.every((p) => selectedInGroup.includes(p));

                    return (
                      <div
                        key={gi}
                        className="grp-row"
                        style={{ marginBottom: 10 }}
                      >
                        <div
                          className="grp-head"
                          onClick={() => toggleGroup(gi)}
                        >
                          <span className="toggle">{isOpen ? "▾" : "▸"}</span>
                          <span className="grp-title">
                            {group?.title || "-"}
                          </span>
                          <span className="pill">
                            {(group?.TabName || []).length} screens
                          </span>
                          <div
                            style={{
                              marginLeft: "auto",
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <Input
                              type="checkbox"
                              checked={allChecked}
                              onChange={(e) =>
                                onSelectAllInGroup(group, e.target.checked)
                              }
                              style={{ width: 18, height: 18 }}
                            />
                            <span style={{ fontSize: 12 }}>Select All</span>
                          </div>
                        </div>

                        {isOpen && (
                          <div>
                            <div
                              className="perm-row"
                              style={{ background: "#fafafa", fontWeight: 700 }}
                            >
                              <div className="perm-name">Screen</div>
                              <div className="perm-col">View</div>
                              <div className="perm-col">Create</div>
                              <div className="perm-col">Edit</div>
                              <div className="perm-col">Delete</div>
                              {isMaster && (
                                <div className="perm-col">Download</div>
                              )}
                              {isMaster && (
                                <div className="perm-col">BulkUpload</div>
                              )}
                            </div>

                            {(group?.TabName || [])
                              .filter(
                                (tab) =>
                                  Array.isArray(tab?.permission) &&
                                  tab.permission.some((p) => p !== "NA")
                              )
                              .map((tab, ti) => {
                                const tabTitle = tab?.title;
                                const perms = Array.isArray(tab?.permission)
                                  ? tab.permission
                                  : [];
                                const current =
                                  selected.find((x) => x.pagename === tabTitle)
                                    ?.permission || [];
                                return (
                                  <div key={ti} className="perm-row">
                                    <div className="perm-name">{tabTitle}</div>
                                    {[
                                      "View",
                                      "Create",
                                      "Edit",
                                      "Delete",
                                      ...(isMaster
                                        ? ["Download", "BulkUpload"]
                                        : []),
                                    ].map((label, pi) => {
                                      const isNA =
                                        perms[pi] === "NA" ||
                                        !perms.includes(label);
                                      if (isNA)
                                        return (
                                          <div
                                            key={pi}
                                            className="perm-col"
                                          ></div>
                                        );
                                      const checked = current.includes(label);
                                      return (
                                        <div key={pi} className="perm-col">
                                          <Input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={(e) => {
                                              const next = e.target.checked
                                                ? Array.from(
                                                    new Set([...current, label])
                                                  )
                                                : current.filter(
                                                    (p) => p !== label
                                                  );
                                              setTabPerm(tabTitle, next);
                                            }}
                                            style={{ width: 18, height: 18 }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 14,
                }}
              >
                <Button type="submit" color="primary">
                  Update
                </Button>
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
}
